module.exports = __webpack_public_path__ + "static/media/nave.af61569c.svg";